export enum PROMPT_TYPE {
  TELEPROPTER_SCRIPT = 'Teleprompter Script',
  EMAIL = 'Email',
  SMS = 'SMS',
  CRM_MESSAGE = 'CRM Message',
}
